import { Component, Input, OnInit } from '@angular/core';
import { DrupalService } from 'src/app/services/drupal.service';
import { getThumbnail, stringSubstr } from 'src/app/utils.ts/helpers';

@Component({
  selector: 'app-place-loader',
  templateUrl: './place_loader.component.html',
  styleUrls: ['./place_loader.component.scss']
})
export class PlaceLoaderComponent implements OnInit {
  mapLoaded: boolean = false;

  stringSubstr = stringSubstr
  getImage = getThumbnail
  @Input() data: any;
  markers: any[] = [];
  showMap: boolean = false;

  constructor(private drupalService: DrupalService) { }

  ngOnInit() {
    this.data.place_loader_places = Array.isArray(this.data.place_loader_places) ? this.data.place_loader_places.filter((place: any) => place.status === true && place.moderation_state != 'archived') : [];
    if (this.data.place_loader_show_map && !this.data.place_loader_places.length) {
      this.showMap = true;
      this.drupalService.getPlacesFromES().subscribe({
        next: (data: any) => {
          for (let place of data.hits.hits) {
            this.markers = [...this.markers, {
              lat: place._source.data.place_gps_latitude_float,
              lng: place._source.data.place_gps_longitude_float,
              title: place._source.data.title,
              popup: `<div class="card card-teaser">
              <div class="card-body">
                <h3 class="card-title h5"><a href="${place._source.data?.path?.alias}" class="text-decoration-none"> ${place?._source.data.title}</a></h3>
                <span class="card-text font-serif">${place._source.data.place_address}, ${place._source.data.place_cap}</span>
              </div>
            </div>`
            }]
          }
        },
        error: console.error,
      })
    } else {
      for (let place of this.data.place_loader_places) {
        this.markers = [...this.markers, {
          lat: place.place_gps_latitude_float,
          lng: place.place_gps_longitude_float,
          title: place.title,
          popup: `<div class="card card-teaser">
            <div class="card-body">
              <h3 class="card-title h5"><a href="${place?.path?.alias}" class="text-decoration-none"> ${place?.title}</a></h3>
              <span class="card-text font-serif">${place.place_address}, ${place.place_cap}</span>
            </div>
          </div>`
        }]
      }

    }
  }



}
